import React from 'react';
import styled from 'styled-components';

const HeroImage = styled.div`
  width: 100%;
  img {
    width: 100%;
  }
`;

export default ({ url }) => (
  <HeroImage>
    <img src={url} alt="Roof Smarter" />
  </HeroImage>
);
